// "What prompted you to try the tool?" on the registration form.
//
// Two nested reveals: the question itself only applies to Lookup Tool signups, and its free-text
// companion only applies when the member picks "Other". Which resource triggers it comes from
// data-motivation-shown-for, so the value lives in the template next to the field it belongs to.
//
// Leaving a branch clears it. A motivation kept from an abandoned answer would be attached to a
// signup it was never given for — harmless while it only sits on the user, but not once it starts
// reaching Salesforce. The server enforces the same rule; this is the visible half of it.
const motivationRoot = document.querySelector("[data-motivation]");

if (motivationRoot) {
  const resourceSelect = document.querySelector('select[name="fields[member__initialResourceRegisteredFor]"]');
  const motivationQuestion = motivationRoot.querySelector("[data-motivation-question]");
  const motivationSelect = motivationRoot.querySelector("#motivation");
  const otherQuestion = motivationRoot.querySelector("[data-motivation-other]");
  const otherInput = motivationRoot.querySelector("#motivation-other");
  const shownFor = motivationRoot.dataset.motivationShownFor;

  const OTHER_OPTION = "Other";

  const refreshOther = () => {
    const isOther = motivationSelect.value === OTHER_OPTION;
    otherQuestion.hidden = !isOther;
    if (!isOther) otherInput.value = "";
  };

  motivationSelect.addEventListener("change", refreshOther);

  resourceSelect?.addEventListener("change", () => {
    const applies = resourceSelect.value === shownFor;
    motivationQuestion.hidden = !applies;

    if (applies) return;

    motivationSelect.value = "";
    refreshOther();
  });
}
